/*
 * @Author: Tina Huang
 * @Date: 2023-01-02 12:39:36
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-16 12:47:38
 * @Description:
 */
import Vue from "vue";
import Code from "../components/BindDialog"; // 引入弹窗组件

const CodeDialog = Vue.extend(Code);

Code.install = function (data = {}) {
  let instance = new CodeDialog({
    data,
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.open();
  });
};

export default Code; // 导出
